import Swiper, { Navigation, Lazy } from 'swiper';
export const init = async function() {
    //@ts-expect-error not able to declare Shopify.Products
    if (!Shopify.Products) {
        return;
    }
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Lazy
    ]);
    // settings
    const settings = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 27
            }
        }
    };
    //@ts-expect-error not able to declare Shopify.Products
    Shopify.Products.recordRecentlyViewed();
    //@ts-expect-error not able to declare Shopify.Products
    Shopify.Products.showRecentlyViewed({
        howManyToShow: 10,
        onComplete: function() {
            // init carousel
            new Swiper('.js-pdp-recently-viewed', settings);
        }
    });
};
